export class NoCurrentClubError extends Error {
  constructor() {
    super('Should have current club');
  }
}
